import { render, staticRenderFns } from "./TransactionPending.vue?vue&type=template&id=7b2b7a6e&scoped=true"
import script from "./TransactionPending.vue?vue&type=script&lang=js"
export * from "./TransactionPending.vue?vue&type=script&lang=js"
import style0 from "./TransactionPending.vue?vue&type=style&index=0&id=7b2b7a6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b7a6e",
  null
  
)

export default component.exports